import React from "react";
import {
  LegacyCard as Card,
  Layout,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage as PolarisSkeletonPage,
  BlockStack,
} from "@shopify/polaris";

const SkeletonPage = () => {
  return (
    <PolarisSkeletonPage secondaryActions={2}>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <BlockStack gap="4">
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </BlockStack>
          </Card>
          <Card sectioned>
            <BlockStack gap="4">
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </BlockStack>
          </Card>
          <Card sectioned>
            <BlockStack gap="4">
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </BlockStack>
          </Card>
        </Layout.Section>
        <Layout.Section secondary>
          <Card>
            <Card.Section>
              <BlockStack gap="4">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={2} />
              </BlockStack>
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={2} />
            </Card.Section>
          </Card>
          <Card subdued>
            <Card.Section>
              <BlockStack gap="4">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={2} />
              </BlockStack>
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={2} />
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={2} />
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={2} />
            </Card.Section>
            <Card.Section>
              <SkeletonBodyText lines={2} />
            </Card.Section>
          </Card>
        </Layout.Section>
      </Layout>
    </PolarisSkeletonPage>
  );
};

export default SkeletonPage;
